import React from "react";
import { Check, Loader2, AlertTriangle } from "lucide-react";

export const fmtEta = (s) => {
  if (s == null) return null;
  if (s < 60) return "under a minute";
  if (s < 3600) return `~${Math.round(s / 60)} min`;
  return `~${Math.floor(s / 3600)} h ${Math.round((s % 3600) / 60)} min`;
};

const Dot = ({ status, n }) => {
  if (status === "done") return <span className="w-8 h-8 rounded-full bg-[#10B981] text-[#04120c] flex items-center justify-center"><Check size={16} /></span>;
  if (status === "running") return <span className="w-8 h-8 rounded-full border-2 border-[#E6B04E] text-[#E6B04E] flex items-center justify-center"><Loader2 size={15} className="animate-spin" /></span>;
  if (status === "failed") return <span className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center"><AlertTriangle size={15} /></span>;
  return <span className="w-8 h-8 rounded-full border border-[#3B4259] text-[#64748B] flex items-center justify-center font-mono text-sm">{n}</span>;
};

export const Stepper = ({ order, steps, active, onSelect }) => (
  <div className="studio-card p-4 flex items-center gap-2 overflow-x-auto" data-testid="wizard-stepper">
    {order.map((o, i) => {
      const st = steps[o.key]?.status || "pending";
      return (
        <React.Fragment key={o.key}>
          {i > 0 && <div className={`h-px flex-1 min-w-6 ${st === "pending" ? "bg-[#252A3B]" : "bg-[#E6B04E]/60"}`} />}
          <button onClick={() => onSelect(o.key)} data-testid={`wizard-step-${o.key}`}
            className={`flex items-center gap-2.5 px-2 py-1 rounded-lg transition-colors ${active === o.key ? "bg-[#212534]" : "hover:bg-[#1a1d29]"}`}>
            <Dot status={st} n={i + 1} />
            <div className="text-left">
              <div className="metric-label" style={{ fontSize: 9 }}>Step {i + 1}</div>
              <div className={`text-sm font-semibold whitespace-nowrap ${active === o.key ? "text-[#E6B04E]" : ""}`}>{o.label}</div>
            </div>
          </button>
        </React.Fragment>
      );
    })}
  </div>
);

export const PhaseList = ({ phases, step, eta, extra = {} }) => {
  const done = step?.phases_done || [];
  return (
    <div className="space-y-2" data-testid="wizard-phase-list">
      {phases.map((p) => {
        const isDone = done.includes(p.key) || step?.status === "done";
        const isRun = !isDone && step?.status === "running" && step?.phase === p.key;
        return (
          <div key={p.key} className="flex items-center gap-3 text-sm" data-testid={`wizard-phase-${p.key}`}>
            {isDone ? <Check size={15} className="text-[#10B981]" /> : isRun ? <Loader2 size={15} className="animate-spin text-[#E6B04E]" />
              : <span className="w-[15px] h-[15px] rounded-full border border-[#3B4259]" />}
            <span className={isDone ? "text-[#94A3B8]" : isRun ? "text-white font-semibold" : "text-[#64748B]"}>{p.label}</span>
            {isRun && extra[p.key] && <span className="metric-label">{extra[p.key]}</span>}
            {isRun && fmtEta(eta) && <span className="metric-label text-[#E6B04E]" data-testid="wizard-eta">{fmtEta(eta)} left</span>}
          </div>
        );
      })}
    </div>
  );
};

export const StepError = ({ step, onRetry }) => step?.status === "failed" ? (
  <div className="flex items-center justify-between gap-3 border border-[#EF4444]/40 bg-[#EF4444]/10 rounded p-3 text-sm" data-testid="wizard-step-error">
    <span className="flex items-center gap-2"><AlertTriangle size={15} className="text-[#EF4444]" />{step.error}</span>
    <button className="btn btn-ghost !py-1 text-xs" onClick={onRetry} data-testid="btn-wizard-retry">Retry</button>
  </div>
) : null;
